export const BillOff = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22 3L7.20003 3C6.53729 3 6.00003 3.53726 6.00003 4.2V26.0046M26 29V5.8064" stroke="currentColor" stroke-width="2"/>
<path d="M26 29H25L22 25L19 29L16 25L13 29L11.5 27" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M28.575 3.42505L3.33069 28.6694" stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
</svg>`;
